// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elebYlk2JFMxCt {
  max-width: 572px;
  margin: 0 auto;
  margin-top: 50px;
  padding: 0 16px;
  text-align: center;
}
@media only screen and (max-width: 750px) {
  .elebYlk2JFMxCt {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - 164px);
    margin-top: 40px;
  }
}
.kab7PnUf3uFyyD {
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  line-height: 24px;
}
.AuQjj4D7O21fzW {
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  line-height: 20px;
}
.srbKHsiUVd8LiM {
  display: flex;
  flex-direction: column;
  height: 560px;
  margin: 24px 0;
  padding: 16px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background: var(--ds-surface-raised, #ffffff);
}
.srbKHsiUVd8LiM.wi7t9d2JPeA259 {
  height: auto;
}
@media only screen and (max-width: 750px) {
  .srbKHsiUVd8LiM {
    flex-basis: auto;
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 170px;
    margin-bottom: 12px;
  }
}
.GUm5Q_PZWo4Vjw {
  padding: 12px;
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_ {
  color: var(--ds-text, #172b4d);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  box-sizing: border-box;
  width: 100%;
  margin: 0;
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_.HGjh6cgkAKw7Xr {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_.HGjh6cgkAKw7Xr:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_.HGjh6cgkAKw7Xr:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_.rSNHgEQLrslRa5 {
  width: 100%;
}
.GUm5Q_PZWo4Vjw .fxyhlyVxRnFUz_::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.iEOjRqR5qvsE0H {
  height: 100%;
  overflow-y: auto;
}
.M_KRa9g5PsvUsw {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.MyC25wSc0WRUEi {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.MyC25wSc0WRUEi .lYRk1IWTob2ID7 {
  margin: 0 12px 24px 12px;
  color: var(--ds-text-subtle, #44546f);
}
@media only screen and (max-width: 750px) {
  .HKMHLO0LVuIReA button {
    width: 100%;
  }
}
@media only screen and (max-width: 750px) {
  .HKMHLO0LVuIReA {
    margin-bottom: 6px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `elebYlk2JFMxCt`,
	"title": `kab7PnUf3uFyyD`,
	"subText": `AuQjj4D7O21fzW`,
	"listBoxContainer": `srbKHsiUVd8LiM`,
	"responsive": `wi7t9d2JPeA259`,
	"searchInputContainer": `GUm5Q_PZWo4Vjw`,
	"searchInput": `fxyhlyVxRnFUz_`,
	"input-error": `HGjh6cgkAKw7Xr`,
	"full": `rSNHgEQLrslRa5`,
	"workspacesContainer": `iEOjRqR5qvsE0H`,
	"spinnerContainer": `M_KRa9g5PsvUsw`,
	"noWorkspaceContainer": `MyC25wSc0WRUEi`,
	"noWorkspaceText": `lYRk1IWTob2ID7`,
	"upgradeButtonContainer": `HKMHLO0LVuIReA`
};
export default ___CSS_LOADER_EXPORT___;
